export const LOG_IN_SUCCESS = 'logged in';
export const APP_SUBMIT_HEAP = 'Submit - Application';
export const APP_SUBMIT_SUCCESS_HEAP = 'Server - Application Submit Success';
export const APP_SUBMIT_ERROR_HEAP = 'Server - Application Submit Error';
export const APP_REJECT_SUCCESS_HEAP = 'Server - Application Reject Success';
export const APP_REJECT_ERROR_HEAP = 'Server - Application Reject Error';
export const NAV_FWD = 'Click - Next Step';
export const NAV_BCK = 'Click - Previous Step';
export const APP_REJOIN_SUCCESS_HEAP = 'Server - Application Rejoin Success';
export const APP_REJOIN_ERROR_HEAP = 'Server - Application Rejoin Error';
export const APP_RELOAD_SUCCESS_HEAP = 'Server - Application Reload Success';
export const APP_RELOAD_ERROR_HEAP = 'Server - Application Reload Error';
export const APP_RENEW_TOKEN_FAILED_HEAP = 'Server - Renew Token Failed';
export const ERROR_RETRY = 'Server - Error Modal Retry';
export const APP_ELIGIBILITY_ERROR_HEAP = 'Server - Application Eligibility Error';
export const BROWSER_NAV_FWD = 'Click - Browser Forward';
export const BROWSER_NAV_BCK = 'Click - Browser Back';
export const RECOVERABLE_ERROR = 'Server - Recoverable Error';
export const UNRECOVERABLE_ERROR = 'Server - Unrecoverable Error';
export const INELIGIBLE_LOAN_ERROR = 'Server - Ineligible loan';
export const PROVISIONAL_OFFER_VIEW = 'View - New PO Page';
export const PROVISIONAL_OFFER_TERM = 'Click - Term change';
export const PROVISIONAL_OFFER_OFFER_OPTIONS = 'Click - Option change';
export const PROVISIONAL_OFFER_TERMS_AND_CONDITIONS = 'Click - Ts & Cs';
export const PROVISIONAL_OFFER_ACCEPT = 'Click - Accept New PO Page';
export const PROVISIONAL_OFFER_DECLINE = 'Click - Decline New PO Page';
export const PROVISIONAL_OFFER_SLIDER = 'Click - Slider Change';
export const PROVISIONAL_OFFER_VIDEO = 'Click - Video Buttons';
export const PROVISIONAL_OFFER_FAQ = 'Click - More FAQ';
export const PROVISIONAL_OFFER_FAQ_ITEM = 'Click - FAQ Item';
export const PROVISIONAL_OFFER_QUESTIONS = 'Click - Common Questions';
export const PROVISIONAL_OFFER_DETAILED_OFFER = 'Click - Show Detailed Offer';
export const PROVISIONAL_OFFER_CUSTOMISE = 'Click - Customise Loan';
export const PROVISIONAL_OFFER_LOAN_TYPE_SELECTION = 'Click - Loan Type Selection';
export const PROVISIONAL_OFFER_COSIGNER_MODAL_OPEN = 'View - Cosigner Modal';
export const PROVISIONAL_OFFER_COSIGNER_OFFER_ACCEPT = 'Click - Accept Offer With Cosigner Details';
export const PROVISIONAL_OFFER_COSIGNER_DOCUMENT_MODAL = 'Click - Cosigner Document Modal';
export const REFERRAL_CODE_GIVEN = 'Click - Next on Referral Code page';
export const REFERRAL_CODE_NOT_GIVEN = 'Click - Skip on Referral Code page';
export const COURSE_UNDER_REVIEW = 'View - Course under review page';
export const UPDATE_SEASON_CLASS_DATA = 'Server - Update Season Class Data';
export const PREVIOUS_EDUCATION = 'View - Previous Education page';
export const SUBMIT_DECLARATIONS = 'Click - Submit Declarations';
export const SUBMIT_TEST_TAKEN = 'Click - Next - Test Taken Page';
